"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledTypography = (0, styled_1.default)('span', {
    shouldForwardProp: (prop) => (0, is_prop_valid_1.default)(prop) && prop !== 'color'
})({
    margin: '0px 0px 0.40em 0px'
}, ({ variant, weight, theme, align, color }) => ({
    ...(align && {
        display: 'block',
        textAlign: align
    }),
    ...(weight === 'semibold' && {
        fontWeight: theme.typography.fontWeightSemiBold
    }),
    ...(weight === 'medium' && {
        fontWeight: theme.typography.fontWeightMedium
    }),
    ...(weight === 'regular' && {
        fontWeight: theme.typography.fontWeightRegular
    }),
    ...(weight === 'light' && {
        fontWeight: theme.typography.fontWeightLight
    }),
    ...(variant === 'small' && {
        color: theme.palette.colors.blackCoral,
        fontSize: 12
    }),
    ...(variant === 'text' && {
        color: theme.palette.colors.coolGrey,
        fontSize: 14
    }),
    ...(variant === 'body1' && {
        color: theme.palette.colors.midnightBlue,
        fontSize: 16
    }),
    ...(variant === 'body2' && {
        color: theme.palette.colors.coolGrey,
        fontSize: 18
    }),
    ...(variant === 'subtitle2' && {
        color: theme.palette.colors.midnightBlue,
        fontSize: 22
    }),
    ...(variant === 'subtitle1' && {
        color: theme.palette.colors.midnightBlue,
        fontSize: 26
    }),
    ...(variant === 'title' && {
        color: theme.palette.colors.midnightBlue,
        fontSize: 28
    }),
    ...(variant === 'jumbo' && {
        color: theme.palette.colors.midnightBlue,
        fontSize: 36
    }),
    ...(color &&
        color in theme.palette.colors && {
        color: theme.palette.colors[color]
    })
}));
exports.default = StyledTypography;
//# sourceMappingURL=StyledTypography.js.map